// Add font family type
export type FontFamily = 'poppins' | 'timesNewRoman' | 'arial' | 'inter' | 'cairo' | 'roboto';
export type FontSize = '14px' | '16px' | '18px' | '20px';

// State interface
export interface CustomContractState {
  selectedFile: File | null;
  numPages: number | null;
  currentPage: number;
  isEditingPage: boolean;
  pageInputValue: string;
  templateName: string;
  fontFamily: FontFamily;
  fontSize: FontSize;
  fields: Array<{
    id: string;
    templateId: string;
    page: number;
    x: number;
    y: number;
    width: number;
    height: number;
    value?: string;
    label?: string;
  }>;
}

// Action types
export const CUSTOM_CONTRACT_ACTIONS = {
  SET_SELECTED_FILE: 'pdfViewer/setSelectedFile',
  SET_NUM_PAGES: 'pdfViewer/setNumPages',
  SET_CURRENT_PAGE: 'pdfViewer/setCurrentPage',
  SET_IS_EDITING_PAGE: 'pdfViewer/setIsEditingPage',
  SET_PAGE_INPUT_VALUE: 'pdfViewer/setPageInputValue',
  SET_TEMPLATE_NAME: 'SET_TEMPLATE_NAME',
  SET_TEMPLATE_FIELDS: 'SET_TEMPLATE_FIELDS',
  SET_FONT_SETTINGS: 'SET_FONT_SETTINGS',
} as const;

// Action interfaces
export interface SetSelectedFileAction {
  type: typeof CUSTOM_CONTRACT_ACTIONS.SET_SELECTED_FILE;
  payload: File | null;
}
export interface SetNumPagesAction {
  type: typeof CUSTOM_CONTRACT_ACTIONS.SET_NUM_PAGES;
  payload: number | null;
}

export interface SetCurrentPageAction {
  type: typeof CUSTOM_CONTRACT_ACTIONS.SET_CURRENT_PAGE;
  payload: number;
}

export interface SetIsEditingPageAction {
  type: typeof CUSTOM_CONTRACT_ACTIONS.SET_IS_EDITING_PAGE;
  payload: boolean;
}

export interface SetPageInputValueAction {
  type: typeof CUSTOM_CONTRACT_ACTIONS.SET_PAGE_INPUT_VALUE;
  payload: string;
}

export interface SetTemplateNameAction {
  type: typeof CUSTOM_CONTRACT_ACTIONS.SET_TEMPLATE_NAME;
  payload: string;
}

export interface SetTemplateFieldsAction {
  type: typeof CUSTOM_CONTRACT_ACTIONS.SET_TEMPLATE_FIELDS;
  payload: any[];
}

export interface SetFontSettingsAction {
  type: typeof CUSTOM_CONTRACT_ACTIONS.SET_FONT_SETTINGS;
  payload: {
    fontFamily: FontFamily;
    fontSize: FontSize;
  };
}

// Union type of all actions`
export type CustomContractActions =
  | SetSelectedFileAction
  | SetNumPagesAction
  | SetCurrentPageAction
  | SetIsEditingPageAction
  | SetPageInputValueAction
  | SetTemplateNameAction
  | SetTemplateFieldsAction
  | SetFontSettingsAction;
